var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon__StyledIcon-sc-1det6wr-0 dZqFBn",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.696 6.566a2.283 2.283 0 110-4.566 2.283 2.283 0 010 4.566zm8.402 10.229l.274 3.744c0 .73-.548 1.37-1.278 1.461-.731 0-1.37-.548-1.462-1.278l-.274-3.836c0-.183-.182-.365-.456-.365H12.71c-1.644 0-3.014-1.188-3.196-2.74l-.73-4.749c-.092-.73.456-1.37 1.186-1.552.73-.092 1.37.456 1.553 1.095l.73 4.84c0 .275.183.457.457.457h2.192c1.644 0 3.014 1.279 3.196 2.923zm-4.749 1.004c.548 0 .914.365.914.913s-.366.914-.914.914H9.788c-1.279 0-2.375-.822-2.649-2.1l-1.461-6.394c-.183-.456.183-1.004.64-1.095.456-.183 1.004.182 1.095.639l1.461 6.393c.092.456.457.73.914.73h3.561z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeating);
export default __webpack_public_path__ + "static/media/seating.5ccf5ada497f99b468f93db561c44cc1.svg";
export { ForwardRef as ReactComponent };